module.exports = __webpack_public_path__ + "static/media/s_v9_t1.06ca01ca.mp3";